/*  MUI  */
import { Box, Typography } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { ClientLink } from 'application/Shared/types/clientLink';

/*  React  */
import React from 'react';

/* Internal */
import { DeviceWarning } from './DeviceWarning';
import { usePartnerClientsTableContext } from './PartnerClientsTableContext';

export const ClientDevicesCell = ({
    row
}: CellContext<ClientLink, unknown>) => {
    const { clientDevices } = usePartnerClientsTableContext();

    return (
        <Box display="flex" alignItems="center" data-testid="clientDevicesCell">
            <Typography variant="body2">
                {clientDevices[row.original.linkedTenantId] || 0}
            </Typography>
            {!clientDevices[row.original.linkedTenantId] && <DeviceWarning />}
        </Box>
    );
};
